import useIsRegister from "@/store/useIsRegister"
import useConnectWallet from "@/store/wallet/useConnectWallet"
import { useCallback, useEffect, useState } from "react"
import { useLocation, useNavigate } from "react-router-dom"

/**
 * useHasReferrer - 检查用户是否已注册 Hook（查询类）
 * 
 * 用于调用 FFR 合约的 hasReferrer 方法检查用户是否已注册。
 * 组件加载时自动执行检查，并根据注册状态进行路由跳转。
 * 如果用户已注册且当前在邀请页面，则自动跳转到首页。
 * 
 * @returns {Object} 返回获取注册状态的方法
 *   - getHasReferrer: 手动检查用户注册状态的函数
 */
const useHasReferrer = () => {
    const navigate = useNavigate()
    const { setIsRegister, isRegister } = useIsRegister()
    const { pathname } = useLocation()
    const [hasReferrerLod, setLoading] = useState(false);
    // 从 useConnectWallet 获取用户地址和 FFR 合约实例
    const { address, contractEvm: { RegularStaking } } = useConnectWallet()

    /**
     * 获取用户注册状态函数
     */
    const getHasReferrer = useCallback(async () => {
        try {
            setLoading(true);
            if (RegularStaking) {
                // 调用合约的 hasReferrer 方法检查是否已注册
                const is = await RegularStaking.hasReferrer(address)
                // 判断是否注册 true 是 false 否
                // 如果跟缓存一样就不调用修改缓存
                if (isRegister !== is) {
                    setIsRegister(is)
                }
                // 判断有没有注册 和当前这的页面是不是注册页面 
                // 注册了且当前页面不是注册页面则跳转到首页，如果没有注册路由守卫会解决的
                if (is && pathname === '/invitation') {
                    navigate('/')
                }
            }
        } catch (e) {
            console.log('useHasReferrer', e);
        } finally {
            setLoading(false);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [RegularStaking, address])
    // 
    // 组件加载时自动检查注册状态
    useEffect(() => {
        getHasReferrer()
    }, [getHasReferrer])

    return { getHasReferrer, hasReferrerLod }
}

export default useHasReferrer